__turbopack_context__.v({
  "filters": "LicenseFilter-module__bKJLrq__filters",
  "title": "LicenseFilter-module__bKJLrq__title",
});
